import { onStartIntro } from './intro-overlay';

class LogoLottie {
    constructor() {
        this.el = document.querySelector('[data-lottie-logo]');
        if (!this.el || typeof lottie == 'undefined') return;

        const data = this.el.querySelector('script[type="application/json"]');
        if (!data) return;

        const animation = lottie.loadAnimation({
            container: this.el,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData: JSON.parse(data.textContent)
        });

        data.remove();

        onStartIntro(() => animation.play());
    }
}

new LogoLottie();
